<template>
  <div id="app">
    <div id="nav">
      <!-- The Navbar Can show in any other views except for Dashboard views and those under it -->
      <NavBar
        v-if="
          $route.matched[0].path != '/dashboard' &&
          $route.matched[0].path != '/admin' &&
          $route.matched[0].path != '/orgadmin' &&
          $route.matched[0].path != ''
        "
      />
      <router-view
        class="pb-4 pt-3"
        :class="[this.$route.name == 'icon' ? 'iconoa' : '']"
      ></router-view>

      <!-- Toaster to Alert Users on an Update of the App and Prompt them to Update.-->
      <b-toast id="update-toast" variant="secondary" solid no-auto-hide no-close-button>
        <template #toast-title>
          <div class="d-flex flex-grow-1 align-items-baseline">
            <b-img
              blank
              blank-color="#ff5555"
              class="mr-2"
              width="12"
              height="12"
            ></b-img>
            <strong class="mr-auto">Update Available!</strong>
          </div>
        </template>
        <template #default>
          <p>New App Update is Available. Click the Button Below to Update</p>
          <b-button @click="updateApp">Update</b-button>
        </template>
      </b-toast>

      <Footer
        class="navbo"
        v-if="
          $route.matched[0].path != '/dashboard' &&
          $route.matched[0].path != '/admin' &&
          $route.matched[0].path != '/orgadmin' &&
          $route.matched[0].path != ''
        "
      />

      <!-- Whatsapp Sticker Button. Only Show on these Pages. -->
      <a href="https://wa.me/2348161431425" class="a-img-wrapper">
        <div
          v-if="
            this.$route.name == 'login' ||
            this.$route.name == 'signup' ||
            this.$route.name == 'upgrade' ||
            this.$route.name == 'landing' ||
            this.$route.name == 'verify' ||
            this.$route.name == 'forgot'
          "
          class="sticky"
        >
          <b-row>
            <b-col cols="3"><div class="img-wrapper"></div></b-col>
            <b-col cols="9"><p class="pt-2">Chat with us</p></b-col>
          </b-row>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import Footer from "@/components/FooterQ.vue";
import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";
import { App } from "@capacitor/app";
import store from "@/store";
import { mapActions } from "vuex";

export default {
  components: {
    NavBar,
    Footer,
  },
  data() {
    return {
      refreshing: false,
      storeObj: {},
    };
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch("loginmaster/setOrigin");

    next(vm => {
      if (Capacitor.isNativePlatform()) {
        vm.getAppStateMobile();
        // vm.updateDetails()
      }
    });

    next();
    //NProgress.done();
  },
  async mounted() {
    this.$store.dispatch("setNativePlatform", Capacitor.isNativePlatform());
    const appInfo = Capacitor.isNativePlatform() ? await App.getInfo() : {};
    this.$store.dispatch("setAppVersion", Capacitor.isNativePlatform() ? appInfo.version : process.env.VUE_APP_CURRENT_VERSION)

    if (Capacitor.isNativePlatform()) {
      this.getAppStateMobile();
    }

  },
  async created() {
    // if (!Capacitor.isNativePlatform()) {
    this.$store.state.isNativePlatform = Capacitor.isNativePlatform();

    const appInfo = Capacitor.isNativePlatform() ? await App.getInfo() : {};
    this.$store.state.appVersion = Capacitor.isNativePlatform()
      ? appInfo.version
      : process.env.VUE_APP_CURRENT_VERSION;
    // console.log(appInfo.version)
    // console.log(Capacitor.isNativePlatform())
    // }

    // Check from the Service Worker if an Update is available. Then call the Function to show the Alert Toast to the user
    document.addEventListener("swUpdated", this.showRefreshUI, {
      once: true,
    });

    // If the Navigator is now refreshing
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (this.refreshing) return;
        window.location.reload();
        this.refreshing = true;
        this.$bvToast.hide("update-toast");
      });
    }
  },
  methods: {
    ...mapActions("loginmaster", [
      "updateDetails"
    ]),
    // Update the Registration file with the Update Object
    showRefreshUI(e) {
      this.registration = e.detail;
      // Show the Update Toast

      this.$bvToast.show("update-toast");
    },
    updateApp() {
      //Update the App and Refresh
      if (!this.registration || !this.registration.waiting) {
        return;
      }
      this.registration.waiting.postMessage("skipWaiting");
    },
    async saveAppStateMobile(storeState) {
      await Preferences.set({
        key: "store",
        value: JSON.stringify(storeState),
      });
    },
    async getAppStateMobile() {
      const ret = await Preferences.get({ key: "store" });
      const savedStore = JSON.parse(ret.value);

      const originalStore = store.state;
      const newStore = {
        ...originalStore,
        ...savedStore,
      };

      store.replaceState(newStore);

      if (newStore.loginmaster.loggedIn) {
        store.watch(
          state => {
            return state;
          },
          async newState => {
            const newObj = { ...newState }
            delete newObj.admin;
            delete newObj.dashboard;

            // console.log(newObj, "Pre Saving");
            await Preferences.set({
              key: "store",
              value: JSON.stringify(newObj)
            });
          },
          { immediate: true }
        );

        // this.updateDetails()

        store.subscribe(async (mutation, state) => {
          const newObj = { ...state }
          delete newObj.admin;
          delete newObj.dashboard;

          // console.log(newObj, "Pre Saving");
          await Preferences.set({
            key: "store",
            value: JSON.stringify(newObj)
          });
        })
        this.updateDetails()
        if (newStore.loginmaster.details.category == "Individual") {
          this.$router.push({
            path: this.$route.name == 'login' ? "/dashboard" : this.$route.fullPath ,
          });
        } else if (newStore.loginmaster.details.category == "Organization") {
          this.$router.push({
            path: this.$route.name == 'login' ? "/orgadmin" : this.$route.fullPath,
          });
        }
      }
    },
  },
};
</script>

<style>
#app {
  font-family: Mulish;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #243057;
}

.navbo {
  text-align: center;
  position: absolute;
  bottom: auto;
  width: 100%;
  background-color: #243057;
}

.iconoa {
  width: 100vw;
  height: 100vh;
}
.sticky {
  position: fixed;
  right: 2rem;
  bottom: 2rem;
  height: 2.5rem;
  border-radius: 60px 60px;
  background-color: rgb(218, 209, 209);
}
.img-wrapper {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50px 50px;
  background-color: #00377b;
  background-image: url("assets/whatsapp.png");
  background-size: contain;
}

.a-img-wrapper {
  display: block;
  border-radius: 50px;
  text-decoration: none;
}

.close-button {
  position: relative;
  left: -40px;
  top: 5px;
  cursor: pointer;
  z-index: 9999;
}

.info-span {
  font-size: 0.8rem;
  color: red;
}

.cursor-pointer {
  cursor: pointer;
}

.flex-listing {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}

.listing-items {
  width: 33%;
}
.field-division {
  margin-top: 7px;
  background-color: white;
  border-radius: 10px 10px;
  padding: 10px;
}
.flex-parent {
  overflow: auto;
  scrollbar-width: thin;
  /* height: 35px; */
}

.flex-child {
  overflow: auto;
  scrollbar-width: thin;
}
.head-p {
  overflow: auto;
  scrollbar-width: thin;
}
.disbanner {
  background-image: linear-gradient(to bottom right, #00377b, #1467cdf0);
}
.banner-title {
  color: white;
  font-size: 1.2rem;
  font-weight: bold;
}
.banner-offer {
  color: white;
}
.banner-price {
  font-size: 1.7rem;
  font-weight: bolder;
}
.banner-cta {
  color: white;
}
.green-link {
  color: #91f2c0;
  font-weight: bold;
}
.green-link:hover {
  color: #91f2c0;
}
.v-button {
  border-radius: 10px 10px;
  width: 10rem;
  height: 3rem;
  background-color: #00984a;
  font-weight: bolder;
  color: white;
  position: relative;
  bottom: -80%;
  border: 0px;
  font-size: 18px;
}
.v-button:hover {
  background-color: white;
  color: #00984a;
  border: 1px solid #00984a;
}

.file-upload-box {
  width: full;
  height: 300px;
  border: 1px dashed black;
  border-radius: 10px 10px;
  display: flex;
  flex-direction: column;
  justify-items: center;
  justify-content: center;
  cursor: pointer;
}

@media screen and (max-width: 999px) {
  .navbo {
    height: 20%;
  }
  .listing-items {
    width: 50%;
  }
  .list-button {
    width: contain;
    font-size: 0.6rem;
    padding: 3px;
  }
  ,
  .v-button {
    width: 7rem;
    height: 2.5rem;
    font-size: 1rem;
  }
}
</style>
